import React, { useEffect } from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import {
	AuthProvider,
	AuthMachine,
	COOKIE_LOGIN_TOKEN_NAME,
	LOGIN_PATH,
	NANI_CLUB_REDIRECT_PATH,
	checkLogin,
	redirectToLogin,
} from "common-components";
const { useAuthState, useAuthDispatch } = AuthProvider;
const { state: AuthStates, eventType: AuthEventType } = AuthMachine;
const AuthGuard = ({ children, ...props }) => {
	return children;
};

/** 未登入也能停留的頁面 */
const PUBLIC_PATHS = [LOGIN_PATH, NANI_CLUB_REDIRECT_PATH];

const RouteWithSubRoutes = (route) => {
	const authDispatch = useAuthDispatch();
	const authState = useAuthState();
	const history = useHistory();
	useEffect(() => {
		if (authState.matches(AuthStates.LoginDone) && checkLogin(COOKIE_LOGIN_TOKEN_NAME) === "") {
			authDispatch(AuthEventType.LoggingOut);
		}
		const pathname = history.location.pathname.toLowerCase();
		const isPublicPath = PUBLIC_PATHS.some((path) => path.toLowerCase() === pathname);
		if (authState.matches(AuthStates.Idle) && !isPublicPath) {
			redirectToLogin(history);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [authState.value]);

	return (
		<Route
			path={route.path}
			exact={route.exact}
			render={(props) => (
				<AuthGuard {...props} {...route}>
					<route.component {...props} {...route} routes={route.routes} />
				</AuthGuard>
			)}
		/>
	);
};

const RenderRoutes = ({ routes = [] }) => (
	<Switch>
		{routes.map((route, i) => (
			<RouteWithSubRoutes key={i} {...route} />
		))}
	</Switch>
);

export default RenderRoutes;
